import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  template: null,
};
export const templateSlice = createSlice({
  name: "template",
  initialState,
  reducers: {
    setTemplate: (state, action) => {
      state.template = action.payload;
    },
    setLogoutTemplate: (state, action) => {
      state.template = null;
    },
  },
});

export const { setTemplate, setLogoutTemplate } = templateSlice.actions;

export default templateSlice.reducer;
